import { Arg, COMPONENT_STATE_ARGS, Metadata, pick } from '../../../utils/spds/metadata';
import Container from './container.gjs';
import FlexColumn from '../layout/flex/column.gjs';
import Super from './base.gjs';
import styles from './helper-text.module.scss';

const METADATA = Metadata.define({
  description: `
    Helper text for SPDS inputs.

    ### Displaying errors

    The helper text can display an error state in one of two ways:

    * Pass the \`@error\` argument with a value of \`true\`. This will display the error state with whatever text is otherwise displayed
    * Pass the \`@errors\` argument as an array of strings representing the errors that should be displayed. This will override the default text
  `,
  extends: [pick(COMPONENT_STATE_ARGS, ['error'])],
  meta: {
    errors: Arg.array({ description: 'Array of error messages to display' }),
    helperText: Arg.string({ description: 'Helper text to display' }).initial('Helper text'),
  },
  name: 'Helper Text',
});

export default class SpdsCoreHelperText extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-helper-text';
  classesToMapToAttrs = ['error'];
  styles = styles;

  get error() {
    return this.args.error ?? this.errors.length > 0;
  }

  get errors() {
    return this.args.errors ?? [];
  }

  <template>
    <FlexColumn
      @content={{@helperText}}
      class={{this.classes}}
      data-test-spds-helper-text
      id={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      {{#if this.errors}}
        {{#each this.errors as |error index|}}
          <Container @content={{error}} data-test-spds-helper-text-error={{index}} />
        {{/each}}
      {{else}}
        {{yield}}
      {{/if}}
    </FlexColumn>
  </template>
}

export const SPDS_CORE_HELPER_TEXT_METADATA = SpdsCoreHelperText.metadata;
